"use client";

import { useSearchParams } from "next/navigation";
import { Suspense, useEffect, useRef } from "react";
import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks.ts";
import { searchDomains } from "@/redux/slices/domains/thunks/searchDomains.ts";
import DomainNameCustomSearchResults, {
  DomainNameCustomSearchResultsProps,
} from "@template/blocks/domain/DomainNameCustomSearchResults";

const DomainNameSearchResults = ({
  ...props
}: Omit<DomainNameCustomSearchResultsProps, "results" | "loading">) => {
  const dispatch = useTypedDispatch();
  const tableRef = useRef<HTMLDivElement>(null);
  const searchParams = useSearchParams();

  const { results, loading } = useTypedSelector(
    (state) => state.domains.search
  );

  const searchValue = searchParams.get("search");

  useEffect(() => {
    if (searchValue) {
      dispatch(searchDomains({ search: searchValue }));
      tableRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [searchValue]);

  return (
    <DomainNameCustomSearchResults
      ref={tableRef}
      results={results}
      loading={loading}
      {...props}
    />
  );
};

export default (props) => (
  <Suspense>
    <DomainNameSearchResults {...props} />
  </Suspense>
);
